import React from 'react';

const About = ({ currentLanguage = 'EN' }) => {
  const getFontClass = () => {
    return currentLanguage === 'KH' ? 'font-khmer' : 'font-inter';
  };

  const content = {
    EN: {
      title: "About Us",
      subtitle: "Your Trusted Beauty & Wellness Partner",
      description: "Welcome to StudioGlow, where beauty meets expertise. We are dedicated to providing exceptional beauty and wellness services in a comfortable and professional environment.",
      mission: {
        title: "Our Mission",
        text: "To help every client look and feel their absolute best through personalized beauty services and expert care."
      },
      story: {
        title: "Our Story",
        text: "Founded with a passion for beauty and wellness, StudioGlow has been serving our community with premium services and professional care. Our team of experienced stylists and therapists are committed to delivering outstanding results."
      },
      values: {
        title: "Why Choose Us",
        items: [
          {
            icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "Expert Team",
            description: "Highly trained and certified professionals"
          },
          {
            icon: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z",
            title: "Quality Products",
            description: "Premium brands and top-quality products"
          },
          {
            icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "Flexible Hours",
            description: "Convenient scheduling to fit your lifestyle"
          },
          {
            icon: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "Customer First",
            description: "Your satisfaction is our top priority"
          }
        ]
      },
      stats: [
        { number: "5+", label: "Years Experience" },
        { number: "1000+", label: "Happy Clients" },
        { number: "10+", label: "Expert Staff" },
        { number: "15+", label: "Services Offered" }
      ]
    },
    KH: {
      title: "អំពីយើង",
      subtitle: "ដៃគូសម្រស់ និងសុខភាពដែលអ្នកទុកចិត្ត",
      description: "សូមស្វាគមន៍មកកាន់ ស្ទុឌីយ៉ូហ្គ្លូ ជាកន្លែងដែលសម្រស់ជួបជាមួយនឹងជំនាញ។ យើងឧទ្ទិសខ្លួនដើម្បីផ្តល់សេវាកម្មសម្រស់ និងសុខភាពដ៏ពិសេសនៅក្នុងបរិយាកាសដ៏ងាយស្រួល និងមានវិជ្ជាជីវៈ។",
      mission: {
        title: "បេសកកម្មរបស់យើង",
        text: "ជួយអតិថិជនគ្រប់រូបឱ្យមើលទៅ និងមានអារម្មណ៍ល្អបំផុតតាមរយៈសេវាកម្មសម្រស់ប្តូរតាមបុគ្គល និងការថែទាំដោយអ្នកជំនាញ។"
      },
      story: {
        title: "រឿងរ៉ាវរបស់យើង",
        text: "បានបង្កើតឡើងដោយចំណង់ចំណូលចិត្តលើសម្រស់ និងសុខភាព ស្ទុឌីយ៉ូហ្គ្លូបានបម្រើសហគមន៍របស់យើងជាមួយនឹងសេវាកម្មដ៏ពិសេស និងការថែទាំដោយវិជ្ជាជីវៈ។ ក្រុមអ្នកជំនាញធ្វើសក់ និងអ្នកព្យាបាលដែលមានបទពិសោធន៍របស់យើងប្តេជ្ញាចិត្តផ្តល់លទ្ធផលដ៏អស្ចារ្យ។"
      },
      values: {
        title: "ហេតុអ្វីជ្រើសរើសយើង",
        items: [
          {
            icon: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "ក្រុមអ្នកជំនាញ",
            description: "អ្នកជំនាញដែលបានបណ្តុះបណ្តាល និងមានវិញ្ញាបនបត្រ"
          },
          {
            icon: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z",
            title: "ផលិតផលគុណភាព",
            description: "ម៉ាកល្បីល្បាញ និងផលិតផលគុណភាពខ្ពស់"
          },
          {
            icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "ម៉ោងបត់បែន",
            description: "កាលវិភាគងាយស្រួលសម្រាប់របៀបរស់នៅរបស់អ្នក"
          },
          {
            icon: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
            title: "អតិថិជនជាមុន",
            description: "ការពេញចិត្តរបស់អ្នកគឺជាអាទិភាពកំពូលរបស់យើង"
          }
        ]
      },
      stats: [
        { number: "៥+", label: "ឆ្នាំបទពិសោធន៍" },
        { number: "១០០០+", label: "អតិថិជនពេញចិត្ត" },
        { number: "១០+", label: "បុគ្គលិកជំនាញ" },
        { number: "១៥+", label: "សេវាកម្មផ្តល់" }
      ]
    }
  };

  const currentContent = content[currentLanguage] || content.EN;

  return (
    <>
      <style>{`
        .font-khmer {
          font-family: 'Khmer OS Siemreap', 'Khmer OS', 'Noto Sans Khmer', sans-serif;
        }

        .font-inter {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }
      `}</style>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className={`text-3xl md:text-4xl font-bold text-gray-900 mb-3 ${getFontClass()}`}>
              {currentContent.title}
            </h2>
            <p className={`text-xl text-[#B08B71] font-semibold mb-4 ${getFontClass()}`}>
              {currentContent.subtitle}
            </p>
            <p className={`text-lg text-gray-600 max-w-3xl mx-auto ${getFontClass()}`}>
              {currentContent.description}
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            {currentContent.stats.map((stat, index) => (
              <div key={index} className="text-center p-6 bg-gray-50 rounded-lg">
                <div className={`text-3xl md:text-4xl font-bold text-[#B08B71] mb-2 ${getFontClass()}`}>
                  {stat.number}
                </div>
                <div className={`text-sm md:text-base text-gray-600 ${getFontClass()}`}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* Mission & Story */}
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Mission */}
            <div className="bg-[#B08B71] bg-opacity-10 p-8 rounded-lg border border-[#B08B71] border-opacity-20">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#B08B71] rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 ${getFontClass()}`}>
                  {currentContent.mission.title}
                </h3>
              </div>
              <p className={`text-gray-700 leading-relaxed ${getFontClass()}`}>
                {currentContent.mission.text}
              </p>
            </div>

            {/* Story */}
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <h3 className={`text-2xl font-bold text-gray-900 ${getFontClass()}`}>
                  {currentContent.story.title}
                </h3>
              </div>
              <p className={`text-gray-700 leading-relaxed ${getFontClass()}`}>
                {currentContent.story.text}
              </p>
            </div>
          </div>

          {/* Why Choose Us */}
          <div>
            <h3 className={`text-2xl md:text-3xl font-bold text-gray-900 text-center mb-10 ${getFontClass()}`}>
              {currentContent.values.title}
            </h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {currentContent.values.items.map((item, index) => (
                <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 hover:border-[#B08B71] hover:shadow-md transition-all">
                  <div className="w-12 h-12 bg-[#B08B71] bg-opacity-10 rounded-lg flex items-center justify-center mb-4">
                    <svg className="w-6 h-6 text-[#B08B71]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                    </svg>
                  </div>
                  <h4 className={`text-lg font-semibold text-gray-900 mb-2 ${getFontClass()}`}>
                    {item.title}
                  </h4>
                  <p className={`text-gray-600 text-sm ${getFontClass()}`}>
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="mt-16 text-center bg-[#B08B71] rounded-lg p-10">
            <h3 className={`text-2xl md:text-3xl font-bold text-white mb-4 ${getFontClass()}`}>
              {currentLanguage === 'EN' ? 'Ready to Experience the Difference?' : 'ត្រៀមខ្លួនដើម្បីជួបប្រទះភាពខុសគ្នា?'}
            </h3>
            <p className={`text-lg text-white mb-6 ${getFontClass()}`}>
              {currentLanguage === 'EN' 
                ? 'Book your appointment today and let us take care of you' 
                : 'កក់ណាត់ជាមុនថ្ងៃនេះ ហើយអនុញ្ញាតឱ្យយើងថែទាំអ្នក'}
            </p>
            <button className={`bg-white text-[#B08B71] px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 ${getFontClass()}`}>
              {currentLanguage === 'EN' ? 'Book Now' : 'កក់ឥឡូវ'}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;